import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalPenuh extends React.Component {
    render() {
        const { showModalPasien, cancelHandler, DeleteHandler2, Model, Model2, List, janjiHandler, janjiHandler2, createHandler, idOffice } = this.props

        return (
            <div>
                
                <Modal show={showModalPasien} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>CEK KETERSEDIAAN JADWAL</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Mohon maaf, pasien telah terdaftar di jadwal ini.
                            Silahkan pilih pasien yang lain <br /> <br />
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Batal</button>
                        {/* <button class="btn btn-danger" onClick={()=>{editHandler(Model._id)}}>Pilih Jadwal Lain </button> */}
                        {/* <button class="btn btn-danger" onClick={()=>{janjiHandler2(Model2._id)}}>Pilih Jadwal Lain </button> */}
                        <button class="btn btn-danger" onClick={()=>{janjiHandler2(idOffice)}}>Pilih Pasien Lain </button>

                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}